<script>
import {defineComponent} from 'vue'
import {getOrderList} from "../api/api";
import {mapGetters} from "vuex";
import headNav from "../components/headNav.vue";
export default defineComponent({
  name: "orderList",
  computed:{...mapGetters(['userInfo'])},
  components:{headNav},
  data(){
    return{
      type:0,
      page:1,
      total:null,
      dataList:[],
      items: []
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList(){
      getOrderList({
        id:this.userInfo.id,
        status:this.type,
        page:this.page,
        limit:10
      }).then( res => {
        console.log(res,"打印res")
        this.dataList = res.data.data.data
        this.total = res.data.data.total
        this.items = []
        this.dataList.map(item => {
          this.items.push({
            Order_No: item.order_no,
            Phone: item.phone,
            Price: `$${item.price}`,
            create_time: item.create_time
          })
        })
      })
    },
    change(type){
      this.type = type
      this.page = 1
      this.total = 0
      this.getList()

    },
    pageChange(e){
      console.log(e)
      this.page = e
      this.getList()
    },
  }
})
</script>

<template>
  <div>
<!--    <head-nav></head-nav>-->
    <b-container class="ok" fluid>
      <b-row>
        <div style="margin-top: 30px;font-weight: 600;font-size: 30px">OrderList</div>
      </b-row>
      <b-row style="margin-top: 50px">
        <b-tabs content-class="mt-3">
          <b-tab title="All" @click="change(0)"></b-tab>
          <b-tab title="Unpaid" @click="change(1)"></b-tab>
          <b-tab title="Paid" @click="change(2)"></b-tab>
          <b-tab title="Processed" @click="change(3)"></b-tab>
        </b-tabs>
      </b-row>
      <b-row>
          <b-table striped hover :items="items"></b-table>
      </b-row>
      <b-row style="margin-bottom: 20px;margin-bottom: 15px">
        <div style="">
          <el-pagination
            background
            :page-size='10'
            layout="prev, pager, next"
            @current-change="pageChange"
            :total="total">
          </el-pagination>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
@media screen and (min-width: 900px) {
  .ok>.row{
    margin-left: 200px;
    margin-right: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/orderList.vue